export default "__VITE_ASSET__BnEmpshy__"